import LayoutPage from "@/views/shared/LayoutPage";

export default [
  {
    path: "/approval",
    component: LayoutPage,
    children: [
      {
        path: "/approval-purchase-request",
        name: "approval-purchase-request",
        component: () =>
          import("@/views/Approval/PurchaseRequest.vue"),
        meta: {
          title: "Approval Purchase Request",
          titleLocalizationCode: "Approval_Purchase_Requests",
          desc: "Approval purchase request page",
          descLocalizationCode: "Approval_Purchase_Request_Page",
          sidebarElement: false,
          permissionCode: "PurchaseRequest.Read",
          //permissionCode: "ApproverPurchaseRequest.Read",
        },
      },
      {
        path: "/approval-purchase-order",
        name: "approval-purchase-order",
        component: () =>
          import("@/views/Approval/PurchaseOrder.vue"),
        meta: {
          title: "Approval Purchase Order",
          titleLocalizationCode: "Approval_Purchase_Orders",
          desc: "Approval purchase order page",
          descLocalizationCode:"Approval_Purchase_Order_Page",
          sidebarElement: false,
          permissionCode: "PurchaseOrder.Read",
          //permissionCode: "ApproverPurchaseOrder.Read",
        },
      },
      // {
      //   path: "/approver-purchase-order/add",
      //   name: "purchase-request-add",
      //   component: () =>
      //     import("@/views/PurchaseRequest/PurchaseRequestAddPage.vue"),
      //   meta: {
      //     title: "Purchase Request Add",
      //     desc: "Purchase request add page",
      //     sidebarElement: false,
      //     permissionCode: "PurchaseRequest.Add",
      //   },
      // },
      // {
      //     path: "/purchase-request/item",
      //     name: "purchase-item",
      //     component: () => import("@/views/PurchaseRequest/PurchaseRequestItemPage.vue"),
      //     meta: { title: "Purchase Request Item", desc:"Purchase request item page", sidebarElement: false}
      // },
    ],
  },
];
